import { Color, IColors, ITheme } from './models'

const colors: IColors = {
  blue: '#280A54',
  primary: process.env.REACT_APP_primaryColor as Color || '#E42313',
  secondary: process.env.REACT_APP_secondaryColor as Color || '#E42313',
  blueLight: '#8136DB',
  greenRadio: '#0DEDAB',
  black: '#232530',
  greyDark: '#58585A',
  grey: '#B7BDCC',
  greyLight: '#E3E6EB',
  greyMedium: '#848EA8',
  almostWhite: '#F3F5FB',
  white: '#FFFFFF',
  green: '#06CB60',
  orange: '#F5C600',
  orangeDark: '#E77230',
  red: '#D83556',
  purple: '#280A54',
  greenNotification: '#0DEDAB',
  lightPink: '#F2EBFB',
  lightGreen: '#E7FDF7',
  yellow: '#E8BD09',
  lightPurple: '#F7F3FD',
  mediumGreen: '#CCF6DE',
  mediumRed: '#F3D6DC',
  transparent: 'transparent'
}

const theme: ITheme = {
  fontFamily: 'Assistant',
  colors,
  textStyles: {
    display: { fontFamily: 'Assistant-Bold', fontSize: 24, color: colors.black },
    title: { fontFamily: 'Assistant-Bold', fontSize: 18, color: colors.black },
    hightlight: {
      fontFamily: 'Assistant-SemiBold',
      fontSize: 18,
      color: colors.black
    },
    body: { fontFamily: 'Assistant', fontSize: 18 },
    subTitle: {
      fontFamily: 'Assistant-SemiBold',
      fontSize: 18,
      color: colors.black
    },
    caption: { fontFamily: 'Assistant', fontSize: 14, color: colors.black },
    button: { fontFamily: 'Assistant-Bold', fontSize: 16, color: colors.black },
    link: {
      fontFamily: 'Assistant-SemiBold',
      fontSize: 14,
      color: colors.primary,
      textDecorationLine: 'underline'
    },
    grey: {
      color: colors.grey
    },
    pickerText: {
      fontFamily: 'Assistant',
      fontSize: 18,
      color: colors.black,
      lineHeight: 23
    }
  }
}

export default theme
